import * as React from 'react';
import * as ReactDom from 'react-dom';



import {Editor, EditorState, RichUtils, convertFromHTML, blocksFromHTML, ContentState} from 'draft-js';

const htmlString =
`<strong>Bold text</strong> <i>Italic text</i><br/ ><br />
http://www.facebook.com <h2>Example link TO FACEBOOK</h2>
<div >
red
</div>
 `

 const blocksFromHTML1 = convertFromHTML(htmlString);
 //blocksFromHTML = convertFromHTML(htmlString);
 const contentState = ContentState.createFromBlockArray(
   blocksFromHTML1.contentBlocks,
   blocksFromHTML1.entityMap,
 );
 

export const EditorConvertToHTML = ()=> {
  const [editorState, setEditorState] = React.useState(
    EditorState.createWithContent(contentState),
  );

 
  
    //setEditorState(EditorState.createWithContent(contentState));


  const styleMap = {
    'RED': {
       color: 'Red'
    },
    'BLUE': {
      color: 'Blue'
    },
    'BLACK': {
      color: 'Black',
      backgroundColor: 'Red'
    },
    'MARKED': {
      backgroundColor: 'Yellow'
    },
      'H1': {
      fontSize: '2em',
      display: 'block',
      marginTop: '0.67em',
      marginBottom: '0.67em',
      marginLeft: '0',
      marginRight: '0'
    },
    'H2': {
      fontSize: '1.5em',
      display: 'block',
      marginTop: '0.83em',
      marginBottom: '0.83em',
      marginLeft: '0',
      marginRight: '0'
    },
    'H3': {
      fontSize: '1.17em',
      display: 'block',
      marginTop: '1em',
      marginBottom: '1em',
      marginLeft: '0',
      marginRight: '0'
    },
    'H4': {
      fontSize: '1em',
      display: 'block',
      marginTop: '1.33em',
      marginBottom: '1.33em',
      marginLeft: '0',
      marginRight: '0'
    },
    'H5': {
      fontSize: '0.83em',
      display: 'block',
      marginTop: '1.67em',
      marginBottom: '1.67em',
      marginLeft: '0',
      marginRight: '0'
    },
    'H6': {
      fontSize: '0.67em',
      display: 'block',
      marginTop: '2.33em',
      marginBottom: '2.33em',
      marginLeft: '0',
      marginRight: '0'
    },
  };
 

  const handleInlineStyle =(styleFormat = 'BOLD')=> {
    setEditorState(RichUtils.toggleInlineStyle(editorState, styleFormat));
  }
    
  return (
    <>
      <span>
      <button onClick={()=>handleInlineStyle('BOLD')}>Bold</button>
      <button onClick={()=>handleInlineStyle('ITALIC')}>Italic</button>
      <button onClick={()=>handleInlineStyle('UNDERLINE')}>Underline</button>
      <button onClick={()=>handleInlineStyle(`STRIKETHROUGH`)}>Strikethrough</button>
      <button onClick={()=>handleInlineStyle(`RED`)}>Red</button>
      <button onClick={()=>handleInlineStyle(`BLUE`)}>Blue</button>
      <button onClick={()=>handleInlineStyle(`BLACK`)}>Black</button>
      <button onClick={()=>handleInlineStyle(`MARKED`)}>Marked</button>
      <button onClick={()=>handleInlineStyle(`H1`)}>H1</button>
      <button onClick={()=>handleInlineStyle(`H2`)}>H2</button>
      <button onClick={()=>handleInlineStyle(`H3`)}>H3</button>
      <button onClick={()=>handleInlineStyle(`H4`)}>H4</button>
      <button onClick={()=>handleInlineStyle(`H5`)}>H5</button>
      <button onClick={()=>handleInlineStyle(`H6`)}>H6</button>
      </span>
      <Editor 
        customStyleMap={styleMap}
        editorState={editorState} 
        onChange={setEditorState} />
    </>
    )
}
